<template>
  <div class="delivery-block">
    <header>
      <h3>Käufer</h3>
    </header>

    <b-form-group label="LFBIS- AMA-Klienten-Nr.:" label-cols="6">
      <b-input type="text" readonly v-model="data.buyerFactory.lfbis" class="text-right float-right" maxlength="8" :style="{ width: '150px' }"
               :disabled="disabled || saving"/>
    </b-form-group>
    <b-form-group label="Name und Anschrift.:">
      <b-textarea readonly v-model="data.buyerFactory.contact" rows="4"
                  :disabled="disabled || saving"/>
    </b-form-group>
  </div>
</template>

<script>
import {ref, watch} from '@vue/composition-api'
import ModalSelectFactory from "@/app/components/delivery/ModalSelectFactory.vue";

export default {
  components: {ModalSelectFactory},
  props: {
    value: { type: Object, required: true },
    disabled: { type: Boolean, required: true },
    saving: { type: Boolean, required: true },
  },

  setup(props, { emit }) {
    const data = ref(props.value)

    watch(data, () => {
      emit('change', data)
    }, { deep: true })

    return {
      data,
    }
  }
}
</script>
